<template>
  <el-dialog
      v-model="dialogVisible"
      title="转码视频"
      height="500px"
      width="650px"
      top="20px"
      :close-on-click-modal="false"
      :append-to-body="true"
      :show-close="true"
      :before-close="()=>handleClose(false)">
    <div class="dialog-item1">
      <div class="hls-player-container">
        <video ref="videoRef" controls class="hls-video"></video>
        <div v-if="error" class="error-message">{{ error }}</div>
        <div v-if="!isSupported" class="unsupported-message">
          您的浏览器不支持HLS播放
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import {ref, defineProps, defineEmits, onMounted, onBeforeUnmount} from 'vue';

const emits = defineEmits(['close'])
const dialogVisible = ref(true)
import Hls from 'hls.js'

const props = defineProps({
  src: {
    type: String,
    required: true
  },
  autoplay: {
    type: Boolean,
    default: false
  }
})
const videoRef = ref()
const hls = ref(null)
const error = ref(null)
const isSupported = ref(Hls.isSupported())

const initPlayer = () => {
  if (!isSupported.value) {
    // 检查浏览器是否原生支持HLS（如Safari）
    if (videoRef.value.canPlayType('application/vnd.apple.mpegurl')) {
      videoRef.value.src = props.src
      if (props.autoplay) {
        videoRef.value.play().catch(e => {
          error.value = '自动播放失败: ' + e.message
        })
      }
    }
    return
  }

  // 使用hls.js
  hls.value = new Hls({
    enableWorker: true, // 启用多线程解码
    maxBufferLength: 30, // 最大缓冲长度（秒）
    maxMaxBufferLength: 600, // 绝对最大缓冲长度
    maxBufferSize: 60 * 1000 * 1000, // 最大缓冲大小（字节）
    maxBufferHole: 0.5 // 最大缓冲空洞（秒）
  })

  hls.value.attachMedia(videoRef.value)
  hls.value.on(Hls.Events.MEDIA_ATTACHED, () => {
    hls.value.loadSource(props.src)
    hls.value.on(Hls.Events.MANIFEST_PARSED, () => {
      if (props.autoplay) {
        videoRef.value.play().catch(e => {
          error.value = '自动播放失败: ' + e.message
        })
      }
    })
  })

  hls.value.on(Hls.Events.ERROR, (event, data) => {
    if (data.fatal) {
      switch (data.type) {
        case Hls.ErrorTypes.NETWORK_ERROR:
          error.value = '网络错误: ' + data.details
          hls.value.startLoad()
          break
        case Hls.ErrorTypes.MEDIA_ERROR:
          error.value = '媒体错误: ' + data.details
          hls.value.recoverMediaError()
          break
        default:
          error.value = '无法播放视频: ' + data.details
          initPlayer()
          break
      }
    }
  })
}

// 开始
 onMounted(()=>{
  //  console.log(Hls.isSupported())
  // if(Hls.isSupported()){
  //   const hls = new Hls()
  //   const url = "https://cdn.memscloud.cn/competition/work/35/%E9%A1%B9%E7%9B%AE%E6%B1%87%E6%8A%A5%E8%A7%86%E9%A2%91%20%20%20%E6%B0%94%E6%9E%90%E7%9F%BF%E5%AE%89%E2%80%94%E2%80%94%E9%9B%86%E6%88%90%E6%B8%A9%E8%A1%A5%E4%BA%8C%E6%B0%A7%E5%8C%96%E7%A2%B3%E4%BC%A0%E6%84%9F%E5%99%A8%E5%8A%A9%E5%8A%9B%E7%9F%BF%E4%B8%8B%E5%AE%89%E5%85%A8_1748877557109.mp4?avcvt/3/format/m3u8&e=1749001091&token=2OT4bQJAVqfhVxcd2DxZnjKjDY44a7yZnOYeZAiV:dBzJvGjEAh8nb-41BFZDOAjlVSc="
  //
  // } else {
  //   alert('您的浏览器不支持 m3u8 播放');
  // }
   console.log(222,videoRef,videoRef.value,videoRef.value)
   setTimeout(()=>{
     if (videoRef.value) {
       initPlayer()
     }
   },2000)

 })
onBeforeUnmount(() => {
  if (hls.value) {
    hls.value.destroy()
  }
})

const handleClose = ()=>{
  dialogVisible.value = false
  emits("close", true)
}

</script>

<style scoped>
.dialog-item1 {
  width: 100%;
  /*height: 450px;*/
  overflow-x: hidden;
  overflow-y: auto;
}
.hls-player-container {
  position: relative;
  width: 600px;
  /*max-height: 100%;*/
}

.hls-video {
  width: 100%;
  background-color: #000;
}

.error-message,
.unsupported-message {
  color: red;
  padding: 10px;
  background-color: #ffeeee;
  border: 1px solid #ffcccc;
  margin-top: 10px;
}
</style>
